export default "__VITE_ASSET__DZ5kvl6h__"